import { action } from 'easy-peasy';
import { ISetDeleteRequestAction } from '../types';

const setDeleteRequest: ISetDeleteRequestAction = action((state, payload) => {
  state.current = payload;
});

export default setDeleteRequest;
